module.exports = __webpack_public_path__ + "media/images/social-share-button/weibo-d89145953b2e04b0bff21fccda600c3e.svg";